export default __webpack_public_path__ + "static/media/mes.2f96f8ee.svg";